﻿import axios from 'axios';
import mixin from './mixin.js';

const orderApp = {
    mixins: [mixin],
    data() {
        return {
            dataApi: '',
            dates: {},
            day: null,
            time: null,
            loading: false,
            topBarOpen: false
        }
    },
    computed: {
        button() {
            if (!this.day || !this.time) return {};
            if (!this.dates[this.day].length || !this.dates[this.day].some(times => times.time === this.time)) return {};
            return this.dates[this.day].find(times => times.time === this.time).availability;
        }
    },
    watch: {
        day(newVal) {
            if (newVal) this.time = this.dates[this.day].length ? this.dates[this.day][0].time : '';
        }
    },
    methods: {
        async init() {
            if (this.$el.parentNode.dataset.api) this.dataApi = this.$el.parentNode.dataset.api;
            this.loading = true;
            const response = await this.fetchData();
            if (response && response.data) {
                this.dates = response.data;
                this.day = Object.keys(this.dates).length ? Object.keys(this.dates)[0] : '';
                if (this.day) {
                    this.time = this.dates[this.day].length ? this.dates[this.day][0].time : '';
                }
            }
            this.loading = false;
        },
        async fetchData() {
            try {
                const response = await axios.post(this.dataApi, {});
                return response;
            } catch (error) {
                console.log(error);
            }
        }
    },
    mounted() {
        this.init();
    }
}

export default orderApp;